const header = $('#header')
const production = header.find('.production')
const produce_icon = header.find('.produce_icon')
const production_serve = header.find('.production_serve')

header.find('.left').on('click', function () {
  location.href = '/'
})

production.on('mouseenter', function () {
  production_serve.show()
  $(this).css({ color: '#1b9d97' })
  produce_icon.css({
    transform: 'rotate(180deg)',
  })
})
production.on('mouseleave', function () {
  production_serve.hide()
  $(this).css({ color: '#333333' })
  produce_icon.css({
    transform: 'rotate(0deg)',
  })
})

production_serve.on('mouseenter', function () {
  $(this).show()
  production.css({ color: '#1B9D97' })
  produce_icon.css({ transform: 'rotate(180deg)' })
})
production_serve.mouseleave(function () {
  $(this).hide()
  production.css({ color: '#333333' })
  produce_icon.css({ transform: 'rotate(0deg)' })
})

const download = header.find('.download')
const download_icon = header.find('.download_icon')
const download_help = header.find('.download_help')

download.on('mouseenter', function () {
  download_help.show()
  $(this).css({ color: '#1b9d97' })
  download_icon.css({
    transform: 'rotate(180deg)',
  })
})
download.on('mouseleave', function () {
  download_help.hide()
  $(this).css({ color: '#333333' })

  download_icon.css({
    transform: 'rotate(0deg)',
  })
})

download_help.on('mouseenter', function () {
  $(this).show()
  download.css({ color: '#1B9D97' })
  download_icon.css({ transform: 'rotate(180deg)' })
})
download_help.on('mouseleave', function () {
  $(this).hide()
  download.css({ color: '#333333' })
  download_icon.css({ transform: 'rotate(0deg)' })
})

header.find('.btnto').on('click', function () {
  window.open($.getEnv().teacherUrl)
})
